import { Component } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'bulk-entry',
  templateUrl: './bulk-entry.component.html',
  standalone: false,
})
export class BulkEntryComponent {
  constructor(private readonly dialogRef: MatDialogRef<BulkEntryComponent>) {}

  public control = new FormControl('');

  public enter(): void {
    this.dialogRef.close(this.control.value);
  }

  public cancel(): void {
    this.dialogRef.close(null);
  }
}
